export const fragmentUpdateQuizBase = /* GraphQL */ `
 fragment fragmentUpdateQuizBase on Quiz {
    id
    name
    code
    domain
    project_id
    timezone
    contacts
    is_template
    tags
    embed_domains
 }`;

export const fragmentUpdateQuizDomain = /* GraphQL */ `
 fragment fragmentUpdateQuizDomain on Quiz {
    id
    name
    code
    domain
    updated_at
 }`;

export const fragmentUpdateQuizName = /* GraphQL */ `
 fragment fragmentUpdateQuizName on Quiz {
    id
    name
 }`;

export const fragmentUpdateQuizTags = /* GraphQL */ `
 fragment fragmentUpdateQuizTags on Quiz {
    id
    tags
    is_template
 }`;

export const fragmentUpdateQuizEmbedDomains = /* GraphQL */ `
 fragment fragmentUpdateQuizEmbedDomains on Quiz {
    id
    embed_domains
 }`;

export const fragmentUpdateQuizLogotype = /* GraphQL */ `
 fragment fragmentUpdateQuizLogotype on Quiz {
    id
    logotype {
      id
      filename
      path
      type
      size
      hint
      created_at
    }
 }`;

export const fragmentUpdateQuizOptionsBase = /* GraphQL */ `
 fragment fragmentUpdateQuizOptionsBase on QuizOptions {
    id
    lang
    hide_label
    show_progress
    show_back_button
    spam_filter {
      enabled
      lead_limit_by_user
    }
 }`;

export const fragmentUpdateQuizOptionsDocs = /* GraphQL */ `
 fragment fragmentUpdateQuizOptionsDocs on QuizOptions {
    id
    custom_privacy_policy_url
 }`;

export const fragmentUpdateQuizOptionsQrCode = /* GraphQL */ `
 fragment fragmentUpdateQuizOptionsQrCode on QuizOptions {
    id
    qr_code {
      utm_source
      utm_medium
      utm_campaign
      utm_term
      utm_content
    }
 }`;

export const fragmentUpdateQuizOptionsConstructor = /* GraphQL */ `
 fragment fragmentUpdateQuizOptionsConstructor on QuizOptions {
    id
    corners
    theme
    lang
    hide_label
    auto_next
    auto_redirect
    auto_redirect_url
    show_progress
    show_back_button
    custom_privacy_policy_url
    spam_filter {
      enabled
      lead_limit_by_user
    }
    benefits {
      start_page
      questions
      contact_page
      finish_page
    }
 }`;

export const fragmentCopyQuizBase = /* GraphQL */ `
 fragment fragmentCopyQuizBase on Quiz {
    id
    code
    name
    domain
    updated_at
 }`;

export const fragmentQuizCollaboratorBase = /* GraphQL */ `
 fragment fragmentQuizCollaboratorBase on QuizCollaborator {
    id
    quiz_id
    user_email
    user_name
    status
    can_manage_quiz
    can_copy
    can_manage_integrations
    can_view_crm
    can_share
    can_transfer
    can_delete
    can_publish
    expires_at
    created_at
    updated_at
    invited_by
    invited_by_user_email
    is_active
 }`;

export const fragmentCopyQuizForWorkboard = /* GraphQL */ `
 fragment fragmentCopyQuizForWorkboard on Quiz {
    id
    code
    domain
    created_at
    updated_at
    name
    integrations {
      id
    }
 }`;
